import Calculator from './Calculator';
import './index.css';

function App() {
  return (
    <div className='app'>
        <Calculator />
    </div>
  )
}

export default App;